function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1546_2678)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.4148 4.08705H26.1251C25.59 4.08697 25.0676 3.92367 24.6278 3.61896L20.0789 0.470528C19.6391 0.165647 19.1167 0.00233623 18.5816 0.00244146H5.56151C4.8644 0.00244141 4.19583 0.279303 3.70281 0.772145C3.20979 1.26499 2.93269 1.93346 2.93243 2.63057V13.4782H51.0438V6.71613C51.0438 6.01885 50.7668 5.35013 50.2738 4.85708C49.7808 4.36404 49.112 4.08705 48.4148 4.08705Z",
  fill: "#823BEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.1186 44.9999H4.85252C4.02817 45 3.2348 44.6858 2.6341 44.1213C2.03339 43.5567 1.67057 42.7844 1.61958 41.9616L0.00548655 15.2626C-0.021055 14.8216 0.0428679 14.3799 0.193327 13.9646C0.343786 13.5492 0.577602 13.169 0.880401 12.8474C1.1832 12.5257 1.54858 12.2694 1.95409 12.0942C2.3596 11.9189 2.79667 11.8285 3.23842 11.8284H50.7336C51.1754 11.8285 51.6124 11.9189 52.0179 12.0942C52.4235 12.2694 52.7888 12.5257 53.0916 12.8474C53.3944 13.169 53.6283 13.5492 53.7787 13.9646C53.9292 14.3799 53.9931 14.8216 53.9666 15.2626L52.3525 41.9616C52.3015 42.7845 51.9385 43.557 51.3376 44.1216C50.7367 44.6862 49.9431 45.0003 49.1186 44.9999Z",
  fill: "#94A1B8"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1546_2678"
}, /*#__PURE__*/React.createElement("rect", {
  width: 53.9734,
  height: 45,
  fill: "white"
})));

function SvgGameFilebrowserFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 45,
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameFilebrowserFolder);
export default __webpack_public_path__ + "static/media/game-filebrowser-folder.2b9f92ee.svg";
export { ForwardRef as ReactComponent };